import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'mr0149',
    ecrans: ['00-2']
});
